import { __assign } from 'tslib';
import React, { forwardRef, useRef, useMemo } from 'react';
import useProps from '../../atom/hook/useProps.js';
import '../../tailwind.css.js';
import { clazzContainer, clazzLabel, clazz, clazzSlot, clazzAffix, clazzInput, clazzSubLabel } from './TextField.styles.js';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

var TextField = forwardRef(function (_props, _ref) {
    var _a = useProps(_props, ['value', 'disabled', 'error', 'size', 'width', 'label', 'helperMessage', 'subLabel', 'required', 'placeholder', 'before', 'after', 'prefix', 'suffix']), props = _a.props, rest = _a.rest;
    var _b = React.useState(false), hasBlurred = _b[0], setHasBlurred = _b[1];
    var ref = useRef(null);
    var error = useMemo(function () {
        return !!props.error || (!!props.required && !props.value && hasBlurred);
    }, [props.error, props.required, props.value, hasBlurred]);
    var onClick = function (ev) {
        var _a, _b, _c;
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("input")[0]) === null || _b === void 0 ? void 0 : _b.focus();
        (_c = rest.onClick) === null || _c === void 0 ? void 0 : _c.call(rest, ev);
    };
    var onBlur = function (ev) {
        var _a;
        if (!hasBlurred) {
            setHasBlurred(true);
        }
        (_a = rest.onBlur) === null || _a === void 0 ? void 0 : _a.call(rest, ev);
    };
    var onChange = function (ev) {
        var _a;
        if (hasBlurred) {
            setHasBlurred(false);
        }
        (_a = rest.onChange) === null || _a === void 0 ? void 0 : _a.call(rest, ev);
    };
    return (React.createElement("div", { ref: ref, className: twMerge(clsx(clazzContainer(props))), style: { width: props.width } },
        props.label && React.createElement("label", { htmlFor: rest.id, className: twMerge(clsx(clazzLabel(props))) },
            props.label,
            props.label && props.required && React.createElement("span", { className: "text-error" }, "*")),
        React.createElement("div", { className: twMerge(clsx(clazz(__assign(__assign({}, props), { error: error, hasAdornment: !!props.prefix || !!props.before, hasAdornments: !!props.prefix && !!props.before, hasAppendage: !!props.after || !!props.suffix, hasAppendages: !!props.after && !!props.suffix })), rest.className)), style: { width: props.width }, onClick: onClick },
            props.before && React.createElement("div", { className: twMerge(clsx(clazzSlot(__assign(__assign({}, props), { position: "left" })))) }, props.before),
            props.prefix && React.createElement("div", { className: twMerge(clsx(clazzAffix(__assign(__assign({}, props), { before: !!props.before, after: !!props.after, prefix: !!props.prefix, suffix: !!props.suffix, position: "left" })))) }, props.prefix),
            React.createElement("input", __assign({}, rest, { ref: _ref, value: props.value, onChange: onChange, required: props.required, disabled: props.disabled, onBlur: onBlur, className: twMerge(clsx(clazzInput(__assign(__assign({}, props), { before: !!props.before, after: !!props.after, prefix: !!props.prefix, suffix: !!props.suffix })))), placeholder: props.placeholder })),
            props.suffix && React.createElement("div", { className: twMerge(clsx(clazzAffix(__assign(__assign({}, props), { before: !!props.before, after: !!props.after, prefix: !!props.prefix, suffix: !!props.suffix, position: "right" })))) }, props.suffix),
            props.after && React.createElement("div", { className: twMerge(clsx(clazzSlot(__assign(__assign({}, props), { position: "right" })))) }, props.after)),
        (props.helperMessage || props.subLabel) && React.createElement("label", { htmlFor: rest.id, className: twMerge(clsx(clazzSubLabel(__assign(__assign({}, props), { error: error })))) }, props.helperMessage || props.subLabel)));
});

export { TextField as default };
